import router, { resetRouter } from "@/router";
import {getToken,setToken,removeToken,getMenu} from '@/utils/auth'

const state = {
  menus: getMenu(),
}
const mutations = {
  SET_MENU: (state, menus) => {
    state.menus = menus;
    // location.reload()
  },
};

const actions = {
  setMenu({ commit }, tokenStr){
    commit("SET_MENU", tokenStr);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
